<template>
    <div>
        <div class="title-box">
            设备信息列表
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item>
                <el-select v-model="queryParams.deviceName" filterable placeholder="选设备名称" clearable>
                    <el-option
                    v-for="item in biz_device_name"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictLabel">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="queryParams.deviceNum" placeholder="设备编号" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-select v-model="queryParams.deviceModel" filterable placeholder="设备型号" clearable>
                    <el-option
                    v-for="item in devTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="queryParams.status" placeholder="设备状态" clearable>
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
        </el-form>
        
        <!-- 表格 -->
         <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
            <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
            <el-table-column prop="deviceName" label="设备名称" align="center"></el-table-column>
            <el-table-column prop="deviceNum" label="设备编号" align="center"></el-table-column>
            <el-table-column prop="deviceModel" label="设备型号" align="center"></el-table-column>
            <el-table-column prop="status" label="设备状态" align="center">
                <template slot-scope="scope">
                    <span>{{ formatterStatus(scope.row.status) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="boxId" label="边缘盒子ID" align="center"></el-table-column>
            <el-table-column prop="sourceTime" label="状态更新时间" align="center" width="135"></el-table-column>
            <el-table-column prop="electrical" label="最新电量" width="100" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="设备供应商" align="center"></el-table-column>
            <el-table-column prop="installTime" label="安装日期" align="center" width="135"></el-table-column>
            <el-table-column prop="installUser" label="安装工程师" align="center"></el-table-column>
            <el-table-column prop="workshopName" label="绑定场景" width="100" align="center" :formatter="formatterScence"></el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                deviceName:"",
                deviceNum:"",
                deviceModel:"",
                status:""
            },
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            // 设备名称
            biz_device_name:[],
            // 设备型号
            devTypeOptions:[],
            //设备状态
            // 0离线，1在线，2故障
            options: [{
                value: 0,
                label: '离线'
            }, {
                value: 1,
                label: '在线'
            }, {
                value: 2,
                label: '故障'
            }]
        }
    },
    mounted() {
        this.handleResize();
        this.getDeviceName();
        this.getDeviceModel();
        window.addEventListener('resize', this.handleResize);
        this.getList();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            // 你可以在这里添加你的处理代码
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化
            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                deviceName:"",
                deviceNum:"",
                deviceModel:"",
                status:""
            }
            this.getList();
        },
        // 状态列格式
        formatterStatus(status) {
            // 0代表在库 2代表已发货 3代表已安装
            if(status==0){
                return "在库";
            }
            else if(status==2){
                return "已发货";
            }
            else if(status==3){
                return "已安装";
            }
            else{
                return "";
            }
        },
        // 处理场景显示
        formatterScence(row){
            return `${row?.factoryName}-${row?.workshopName}-${row?.sceneName}`;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        // 获取设备名称
        getDeviceName(){
            this.$store.dispatch('dict/getDict', 'biz_device_name').then((result)=>{
                if(result?.data){
                    this.biz_device_name = result.data;
                }
        });
        },
        // 获取设备型号
        getDeviceModel(){
            this.$store.dispatch('device/listDeviceType').then((result)=>{
                if(result){
                    this.devTypeOptions = result.rows;
                }
            });
        },
        getList(){
            this.$store.dispatch('device/getDeviceList', this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            }); 
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
</style>